import type { FC } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

export const DragDropContainer: FC<{
  onDragEnd: (result: any, provided?: any) => void;
  children: React.ReactNode;
}> = ({ onDragEnd, children }) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {children}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
